import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=a961f062&scoped=true"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=ts"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&id=a961f062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a961f062",
  null
  
)

export default component.exports